/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {callWSFunction} from "../APIClient.jsx";


const Certificates = function (certId) {
    async function create(containerId, domainName) {

    }


    async function getInfo() {

    }

    async function doesExist() {

    }

    async function checkDNSTarget() {

    }


    async function update(values) {
        return callWSFunction("certificates.update", {
            certId: certId,
            values: values
        })
    }


    async function verify() {


    }


    async function check() {
        return callWSFunction("certificates.check", {
            certId: certId,
        })
    }

    async function remove() {
        return callWSFunction("certificates.remove", {
            certId: certId,
        })
    }


    return {create, verify, check, getInfo, remove}
}

export default Certificates;